import './overlayConfettiAnimation.styl';
import party from 'party-js';

import { useEffect } from 'react';

export interface IOverlayConfettiAnimation {
    startDelay?: number;
}
export const OverlayConfettiAnimation = ({ startDelay = 0 }: IOverlayConfettiAnimation) => {
    const shootConfetti = (confettiDot: HTMLElement) => {
        party.confetti(confettiDot, {
            count: party.variation.range(27, 37),
            size: party.variation.range(1.2, 2),
            speed: party.variation.range(200, 650),
            spread: party.variation.range(20, 40)
        });
    };

    useEffect(() => {
        party.settings.zIndex = 100;
        const confettiBoxLeft: HTMLElement | null = document.querySelector('.confetti-dot-left');
        const confettiBoxCenter: HTMLElement | null = document.querySelector('.confetti-dot-center');
        const confettiBoxRight: HTMLElement | null = document.querySelector('.confetti-dot-right');

        let leftTimer: NodeJS.Timeout | undefined;
        let centerTimer: NodeJS.Timeout | undefined;
        let rightTimer: NodeJS.Timeout | undefined;

        if (confettiBoxLeft && confettiBoxCenter && confettiBoxRight) {
            leftTimer = setTimeout(() => {
                shootConfetti(confettiBoxLeft);
            }, startDelay);
            centerTimer = setTimeout(() => {
                shootConfetti(confettiBoxRight);
            }, startDelay + 120);
            rightTimer = setTimeout(() => {
                shootConfetti(confettiBoxCenter);
            }, startDelay + 240);
        }

        return () => {
            clearTimeout(leftTimer);
            clearTimeout(centerTimer);
            clearTimeout(rightTimer);
        };
    }, []);

    return (
        <div className="confetti-container">
            <div className="confetti-dot confetti-dot-left"></div>
            <div className="confetti-dot confetti-dot-center"></div>
            <div className="confetti-dot confetti-dot-right"></div>
        </div>
    );
};
